import {
  Car16,
  Highway16,
  MetroEkb16,
  MetroKazan16,
  MetroMoscow16,
  MetroNn16,
  MetroNovosib16,
  MetroSamara16,
  MetroSpb16,
  Walk16,
  Train16,
} from '@cian/ui-kit/icons';
import * as React from 'react';

import { ETransportType } from '../../repositories/search-offers.legacy/v2/types/NewbuildingSimilarBlockOfferForDesktopSchema';
import { INewbuildingSimilarOffer, INewbuildingSimilarOfferTransformed } from '../../types/newbuildingSimilarOffer';

const ICON_GRAY_HEX_COLOR = '#737a8e';

export const getUndergroundIcon = (undergroundType?: string | null): React.ReactNode => {
  switch (undergroundType) {
    case 'spb':
      return <MetroSpb16 color={'current_color'} />;
    case 'smr':
      return <MetroSamara16 color={'current_color'} />;
    case 'ekb':
      return <MetroEkb16 color={'current_color'} />;
    case 'kzn':
      return <MetroKazan16 color={'current_color'} />;
    case 'nn':
      return <MetroNn16 color={'current_color'} />;
    case 'nsk':
      return <MetroNovosib16 color={'current_color'} />;
    default:
      return <MetroMoscow16 color={'current_color'} />;
  }
};

export const mapNewbuildingSimilarOffers = (
  offers: INewbuildingSimilarOffer[],
): INewbuildingSimilarOfferTransformed[] => {
  return offers.reduce((acc, current) => {
    const {
      underground,
      highway,
      railway,
      floor,
      offerUrl,
      imageUrl,
      price,
      address,
      newbuildingName,
      totalArea,
      rootCount,
      analytics,
    } = current;
    const description = [`${rootCount} ･ `, `${totalArea} ･ `, floor];
    let locationText = null;
    let locationIconColor = null;
    let locationIcon = null;
    let timeText = null;
    let timeIcon = null;

    if (underground) {
      const isWalkingTime = underground.transportType === ETransportType.Walk;
      locationText = underground.name;
      locationIconColor = `#${underground.lineColor}`;
      locationIcon = getUndergroundIcon(underground.undergroundType);
      timeIcon = isWalkingTime ? <Walk16 color={'gray_icons_100'} /> : <Car16 color={'gray_icons_100'} />;
      timeText = `${underground.time} мин.`;
    } else if (highway) {
      locationText = highway.name;
      locationIconColor = ICON_GRAY_HEX_COLOR;
      locationIcon = <Highway16 color={'current_color'} />;
      timeText = highway.distance;
    } else if (railway) {
      locationText = railway.name;
      locationIconColor = ICON_GRAY_HEX_COLOR;
      locationIcon = <Train16 color={'current_color'} />;
      timeText = railway.distance;
    }

    acc.push({
      title: newbuildingName,
      imageUrl,
      price,
      description,
      address,
      locationIcon,
      locationIconColor,
      locationText,
      timeIcon,
      timeText,
      url: offerUrl,
      product: analytics,
    });

    return acc;
  }, [] as INewbuildingSimilarOfferTransformed[]);
};
